// @generated by TypeGen from LogbookModel/Settings.swift - DO NOT EDIT

import type { IShipData } from "./Settings/ShipData"
import type { IShipSettings } from "./Settings/ShipSettings"

export interface ISettings {
  id: number;
  accountId: number;
  shipId: number;
  userId: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  data: string;
  settingType: ISettingsType;
}

export interface IAccountSettingsData {
}

export interface ITestSettingsData {
}

export interface IUserSettingsData {
}

export interface ISettingsResponse {
  settings: ISettings[];
}

export enum ISettingsType {
  account = 1,
  user = 2,
  ship = 3,
  shipData = 4,
  test = 100,
}

export interface ISettingsDataMap {
  [ISettingsType.account]: IAccountSettingsData;
  [ISettingsType.user]: IUserSettingsData;
  [ISettingsType.ship]: IShipSettings;
  [ISettingsType.shipData]: IShipData;
  [ISettingsType.test]: ITestSettingsData;
}

export type ISettingsParsed = { [K in ISettingsType]: Omit<ISettings, "data"> & { settingType: K; dataParsed: ISettingsDataMap[K] } }[ISettingsType];

export const Settings = {
  parse(r: ISettings): ISettingsParsed {
    return { ...r, dataParsed: r.data != null ? JSON.parse(r.data) : {} } as ISettingsParsed;
  },
};
